<div class="animated fadeInRight" style="padding: 24px;">
    <mat-form-field appearance="fill" class="input-field">
        <mat-label>{{'Kundenkonto.Zeitraum' | translate}}</mat-label>
        <mat-select [(ngModel)]="this.Zeitraum" (selectionChange)="calcZeitraum()">
            <mat-option [value]="0">{{'Kundenkonto.Diesenmonat' | translate}}</mat-option>
            <mat-option [value]="1">{{'Kundenkonto.Letzenmonat' | translate}}</mat-option>
            <mat-option [value]="2">{{'Kundenkonto.Diesesjahr' | translate}}</mat-option>
            <mat-option [value]="3">Individuell</mat-option>
        </mat-select>
    </mat-form-field>

    @if (Zeitraum == 3) {
    <mat-form-field appearance="fill" class="input-field">
        <mat-label>{{'Kundenkonto.Datumvon' | translate}}</mat-label>
        <input matInput style="margin: 0px"
               [ngModel]="this.Von | date:'dd.MM.yyyy'" (ngModelChange)="this.Von=this.oroservice.ChangeDate($event);" (change)="refresh()"
               autocomplete='off'>
        <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='this.Von' (dateChange)="refresh()">
        <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
        <mat-datepicker #pickerVon></mat-datepicker>
    </mat-form-field>
    }

    @if (Zeitraum == 3) {
    <mat-form-field appearance="fill" class="input-field">
        <mat-label>{{'Kundenkonto.Datumbis' | translate}}</mat-label>
        <input matInput style="margin: 0px"
               [ngModel]="this.Bis | date:'dd.MM.yyyy'" (ngModelChange)="this.Bis=this.oroservice.ChangeDate($event);" (change)="refresh()"
               autocomplete='off'>
        <input type="hidden" [matDatepicker]="pickerBis" [(ngModel)]='this.Bis' (dateChange)="refresh()">
        <mat-datepicker-toggle matSuffix [for]="pickerBis" tabindex="-1"></mat-datepicker-toggle>
        <mat-datepicker #pickerBis></mat-datepicker>
    </mat-form-field>
    }

    @if (errorMessage) {
    <div class="row">
        <mat-error class="mb-3">{{ errorMessage | translate }}</mat-error>
    </div>
    }

    @if (this.isLoading) {
    <div>
        <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
    </div>
    }

    @if (!this.isLoading) {
    <div class="row no-padding">
        <table mat-table [dataSource]="kontoauszug" style="width: 100%;" class="mat-elevation-z2">
            <ng-container matColumnDef="Datum">
                <mat-header-cell *matHeaderCellDef>
                    {{'Kundenkonto.Buchungsdatum' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Created}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Bemerkung">
                <mat-header-cell *matHeaderCellDef>
                    {{'Kundenkonto.Buchungstext' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Anfangssaldo ? ('Anfangssaldo' | translate) : element.Endsaldo ? ('Endsaldo' | translate) : element.Text}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Schuldner">
                <mat-header-cell *matHeaderCellDef>
                    {{'Kundenkonto.Rechnungsempfaenger' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Rechnungsempfaenger}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Betrag">
                <mat-header-cell *matHeaderCellDef class="amount-cell">
                    {{'Kundenkonto.Betrag' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="amount-cell" [ngStyle]="{'color': checkColor(element) ? 'black' : 'red'}">
                    {{checkAnfangOrEndSaldo(element) ? '' : 'CHF ' + betragToString(element)}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Saldo">
                <mat-header-cell *matHeaderCellDef class="amount-cell">
                    {{'Kundenkonto.Saldo' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="amount-cell" [ngStyle]="{'color': checkColorSaldo(element) ? 'black' : 'red'}">
                    {{ checkColorSaldo(element) ? 'CHF ' + saldoToString(element) : 'CHF -' + saldoToString(element) }}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="kontoColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: kontoColumns;" (click)="selectRow(row)" [ngStyle]="{'font-weight': checkFontWeight(row) ? 'bolder' : 'normal'}"></mat-row>
        </table>
    </div>
    }
